import styled from 'styled-components';

import { theme } from '../themes/default';
import { HeroProps } from './Hero';

export const StyledHero = styled.div<Partial<HeroProps>>`
  position: relative;
  height: ${({ isSmallScreen }) => (isSmallScreen ? '110px' : 'auto')};
  display: flex;
  flex-direction: row;
  padding: ${({ isSmallScreen }) => (isSmallScreen ? '30px 16px' : '20px 40px 22px 40px')};
  align-items: center;
  background: ${({ isSmallScreen }) => (isSmallScreen ? 'rgba(246, 246, 250, 0.5)' : '#F8F8FD')};
  border-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '1px solid #e6e6f0;' : 'none')};
  &:after {
    display: ${({ isSmallScreen }) => (isSmallScreen ? 'none' : 'block')};
    position: absolute;
    content: '';
    height: 1px;
    background: #e6e6f0;
    left: -40px;
    bottom: 0;
    width: calc(100% + 80px);
  }
  ${({ size, isSmallScreen }) =>
    size === 'small' &&
    `
      border-radius: ${theme.borderRadius};
      margin-top: 32px;
      height: ${isSmallScreen ? '140px' : '240px'};
      flex-direction: column;
      padding: ${isSmallScreen ? '40px 24px' : '80px'};
      justify-content: center;
      background: ${theme.signUpBackground};
      text-align: ${isSmallScreen ? 'left' : 'center'};
      align-items: ${isSmallScreen ? 'start' : 'center'};
      &:after {
        display: none;
      }
    `};
`;
export const StyledHeroLogo = styled.div<Partial<HeroProps>>`
  display: block;
  width: 59px;
  height: 58px;
  margin-right: 18px;
  background-image: ${(props) => `url(${props.image})`};
  background-repeat: no-repeat;
  background-size: 100%;
  ${({ size, isSmallScreen }) =>
    size === 'small' &&
    `
    position: absolute;
    width: ${isSmallScreen ? '135px' : '269px'};
    height: ${isSmallScreen ? '105px' : '210px'};
    right: ${isSmallScreen ? '5px' : '35px'};
    bottom: 0;
    margin-right: 0;
  `};
`;
export const StyledHeroTitle = styled.h1<Partial<HeroProps>>`
  margin-bottom: 0;
  font-weight: 700;
  font-size: ${({ isSmallScreen }) => (isSmallScreen ? '24px' : '32px')};
  line-height: 1.2;
  ${({ size, isSmallScreen }) =>
    size === 'small' &&
    `
    font-size: ${isSmallScreen ? '24px' : '48px'};
    font-weight: ${isSmallScreen ? '600' : '700'};
    max-width: ${isSmallScreen ? '200px' : '100%'};
    margin-bottom: 10px;
  `};
`;
export const StyledHeroSubTitle = styled.span<Partial<HeroProps>>`
  font-weight: ${({ isSmallScreen }) => (isSmallScreen ? '400' : '500')};
  font-size: ${({ isSmallScreen }) => (isSmallScreen ? '12px' : '15px')};
  line-height: ${({ isSmallScreen }) => (isSmallScreen ? '16px' : '20px')};
  color: ${({ isSmallScreen }) => (isSmallScreen ? '#323234' : '#8E8FA1')};
  ${({ size, isSmallScreen }) =>
    size === 'small' &&
    `
    display: inline-block;
    max-width: ${isSmallScreen ? '200px' : '100%'};
    font-size: ${isSmallScreen ? '12px' : '15px'};
    color: ${theme.mainBlack};
  `};
`;
export const StyledHeroContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const StyledHeroLeft = styled.div`
  display: flex;
`;
